import API_URL from '../apiconfig';
import {
  CancellationWaitlistEntryDetail,
  CancellationWaitlistEntryRow,
  CancellationWaitlistListMeta,
  CancellationWaitlistSettings,
  ManualNotifyPayload,
  UpdateCancellationWaitlistSettingsPayload,
} from '../types/cancellation-waitlist';
import axios from './api';
import client from '../utils/react-query/client';

export const getCancellationWaitlistSettings = async () => {
  const response = await axios.get(
    `${API_URL}/v1/cancellation-waitlist/settings`,
  );
  return response.data.result as CancellationWaitlistSettings;
};

export const updateCancellationWaitlistSettings = async (
  payload: UpdateCancellationWaitlistSettingsPayload,
) => {
  const response = await axios.patch(
    `${API_URL}/v1/cancellation-waitlist/settings`,
    payload,
  );
  return response.data.result as CancellationWaitlistSettings;
};

export const getCancellationWaitlistEntries = async ({
  businessId,
  employeeIds,
  limit,
  cursor,
}: {
  businessId: string;
  employeeIds: string[];
  limit?: number;
  cursor?: string;
}) => {
  const response = await axios.get(`${API_URL}/v1/cancellation-waitlist`, {
    params: { businessId, employeeIds: employeeIds.join(','), limit, cursor },
  });
  return {
    entries: response.data.result as CancellationWaitlistEntryRow[],
    meta: response.data.meta as CancellationWaitlistListMeta,
  };
};

export const getCancellationWaitlistEntry = async (waitlistEntryId: string) => {
  const response = await axios.get(
    `${API_URL}/v1/cancellation-waitlist/${waitlistEntryId}`,
  );
  return response.data.result as CancellationWaitlistEntryDetail;
};

export const removeCancellationWaitlistEntry = async (
  waitlistEntryId: string,
) => {
  const response = await axios.post(
    `${API_URL}/v1/cancellation-waitlist/${waitlistEntryId}/remove`,
  );
  return response.data.result as { id: string; removed: boolean };
};

export const manuallyNotifyCancellationWaitlistEntry = async ({
  waitlistEntryId,
  startDateTime,
  endDateTime,
}: ManualNotifyPayload) => {
  const response = await axios.post(
    `${API_URL}/v1/cancellation-waitlist/${waitlistEntryId}/notify`,
    { startDateTime, endDateTime },
  );
  return response.data.result as { sent: boolean };
};

export async function invalidateWaitlistEntries() {
  await client.invalidateQueries({
    queryKey: ['cancellation-waitlist'],
    exact: false,
  });
}

export async function invalidateWaitlistEntry(waitlistEntryId: string) {
  await client.invalidateQueries({
    queryKey: ['cancellation-waitlist-entry', waitlistEntryId],
  });
}

export async function invalidateWaitlistSettings() {
  await client.invalidateQueries({
    queryKey: ['cancellation-waitlist-settings'],
  });
}
